import {
  Appointment,
  Customer,
  Fitter,
  LocationDataGeocoded,
} from '../commons';
import { AppointmentSheetValidationData } from '../ui-types';

export interface AppointmentValidationInputData {
  onlyReplacementVehicle?: boolean;
  displayReplacementVehicleSelection: boolean;
  location: LocationDataGeocoded;
  appointment?: Appointment;
  customer?: Customer;
  fitter: Fitter;
}

export interface AppointmentValidationSuccess {
  type: 'success';
  data: AppointmentSheetValidationData;
}

export interface AppointmentValidationCancel {
  type: 'cancel';
}

export type AppointmentValidationOutputData =
  | AppointmentValidationSuccess
  | AppointmentValidationCancel;
